import type { BariPreMdoReportData } from '@common/validation/customControls/bariPre/bariPreMdoReport/v1/bariPreMdoReportSchemaV1';
import { CustomControlCode } from '@common/enums';
import { CustomControlRegistry } from '@frontend/components/pages/episodeCategory/customControls/customControlRegistry';
import { bariPreIndicatieVoorVerwijzingReadSectionsTransformer } from '../utils';
import { initialData } from './bariPreMdoReportData';
import { BariPreMdoReportEdit } from './BariPreMdoReportEdit';
import { BariPreMdoReportRead } from './BariPreMdoReportRead';

CustomControlRegistry.instance.register<BariPreMdoReportData>({
    EditElement: BariPreMdoReportEdit,
    ReadElement: BariPreMdoReportRead,
    canCopyReadSections: true,
    code: CustomControlCode.BariPreMdoReport,
    initialData,
    readSectionsTransformer: bariPreIndicatieVoorVerwijzingReadSectionsTransformer,
    version: 1,
});
